module.exports = __webpack_public_path__ + "static/media/loader.168fe125.svg";